import DownloadIcon from "@mui/icons-material/Download";
import { Grid, IconButton, Link } from "@mui/material";

import MDTypography from "@/components/atoms/MDTypography";
import { IMedia } from "@/interfaces/media.interface";
import { CurrentChatMessages } from "@/messages/chat/current-chat.messages";

interface DocumentProps {
  media: IMedia;
  mediaURL: string;
  messages: CurrentChatMessages;
  isSentByUser: boolean;
}

const DocumentMedia: React.FC<DocumentProps> = ({ media, mediaURL, isSentByUser }) => {
  const hasExtension = media.name.includes(`.${media.extension}`);
  const fileName = hasExtension ? media.name : `${media.name}.${media.extension}`;
  const fontColor = !isSentByUser ? "black" : "white";

  return (
    <Grid>
      <Link
        href={mediaURL}
        download={fileName}
        underline="none"
        sx={{ display: "flex", alignItems: "center" }}
      >
        <MDTypography
          variant="subtitle1"
          sx={{ cursor: "pointer", marginRight: 1, color: fontColor }}
          gutterBottom
          fontWeight="bold"
        >
          {media.name}
        </MDTypography>
        <IconButton color="primary">
          <DownloadIcon style={{ fontSize: 25, color: fontColor }} />
        </IconButton>
      </Link>

      {media.caption && <MDTypography variant="body2">{media.caption}</MDTypography>}
    </Grid>
  );
};

export default DocumentMedia;
